export interface PieItem {
  name: string;      // raw key
  value: number;     // numeric value (bytes)
}

// Convert bytes → KB/MB/GB readable format
function formatBytes(bytes: number): string {
  if (bytes >= 1024 * 1024 * 1024) {
    return (bytes / (1024 * 1024 * 1024)).toFixed(1) + " GB";
  }
  if (bytes >= 1024 * 1024) {
    return (bytes / (1024 * 1024)).toFixed(1) + " MB";
  }
  if (bytes >= 1024) {
    return (bytes / 1024).toFixed(1) + " KB";
  }
  return bytes + " B";
}

export function buildPieV2(rows: any[], top = 10): PieItem[] {
  const map = new Map<string, number>();

  for (const r of rows) {
    let key = r.group;

    // Skip invalid keys
    if (
      key === null ||
      key === undefined ||
      key === "-" ||
      (typeof key === "string" && key.trim() === "")
    ) {
      continue;
    }

    const val = Number(r.bytes || 0);
    map.set(key, (map.get(key) || 0) + val);
  }

  let arr = Array.from(map.entries()).map(([name, value]) => ({
    name,
    value
  }));

  arr.sort((a, b) => b.value - a.value);

  // Group remaining items into "Other"
  if (arr.length > top) {
    const topItems = arr.slice(0, top);
    const other = arr.slice(top);
    const otherSum = other.reduce((t, x) => t + x.value, 0);
    arr = [...topItems, { name: "Other", value: otherSum }];
  }

  // Add formatted labels
   return arr.map(x => ({
    name: `${x.name} (${formatBytes(x.value)})`,
    value: x.value
  }));
}

// export function buildPie(rows: any[], field: string, top = 10): PieItem[] {
//   const map = new Map<string, number>();

//   for (const r of rows) {
//     const key = (r[field] || "(unknown)").trim() || "(unknown)";
//     const val = Number(r.bytes_sum || 0);
//     map.set(key, (map.get(key) || 0) + val);
//   }

//   // Convert map → array
//   let arr = Array.from(map.entries()).map(([name, value]) => ({ name, value }));

//   // Sort desc
//   arr.sort((a, b) => b.value - a.value);

//   // Top + Other
//   if (arr.length > top) {
//     const topItems = arr.slice(0, top);
//     const other = arr.slice(top);
//     const otherSum = other.reduce((t, x) => t + x.value, 0);
//     return [...topItems, { name: "Other", value: otherSum }];
//   }

//   return arr;
// }




